import Vue from 'vue';
import Vuex from 'vuex';

import auth from './modules/auth';
import objects from './modules/objects';
import devices from './modules/devices';
import rooms from './modules/rooms';
import mqtt from './modules/mqtt';
import integrations from './modules/integrations';
import cameras from './modules/cameras';
import events from './modules/events';
import automations from './modules/automations';
import triggers from './modules/triggers';
import schedules from './modules/schedules';
import notifications from './modules/notifications';
import graphs from './modules/graphs';
import requester from './modules/requester';
import twofactor from './modules/twofactor';
import fido from './modules/fido';
import uuid from './modules/uuid';
import log from './modules/log';
import ui from './modules/ui';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    rooms,
    objects,
    devices,
    mqtt,
    integrations,
    cameras,
    automations,
    triggers,
    schedules,
    notifications,
    events,
    graphs,
    requester,
    twofactor,
    fido,
    uuid,
    log,
    ui
  }
});
